import type { IntakeJourneyStage } from './components/four-stage/IntakeJourneyShell';
import type { IntakeStatusTab } from './components/four-stage/IntakeStatusDashboard';

const STAFF_INTAKE_PATH = '/admin-v2/intake-status';

/** Only the fleet dashboard is a return destination; never accept an origin or another route. */
export function safeIntakeReturnTo(value: string | null | undefined): string | undefined {
  if (!value || value.includes('\\')) return undefined;
  for (const character of value) {
    const code = character.charCodeAt(0);
    if (code <= 32 || code === 127) return undefined;
  }
  const [pathname] = value.split('?');
  if (pathname !== STAFF_INTAKE_PATH || value.includes('#')) return undefined;
  return value;
}

export function resolveAdminStatusTab(search: string): IntakeStatusTab {
  const params = new URLSearchParams(search);
  const tab = params.get('statusTab') ?? params.get('intakeStatus');
  if (tab === 'billing' || tab === 'credentialing' || tab === 'ehr-import') return tab;
  return params.get('intakeStage') === 'import' ? 'ehr-import' : 'billing';
}

/** Presentation routing only. The org owner must validate providerScope against its members. */
export function buildAdminIntakeHubPath({
  organizationId,
  stage = 'agreements',
  statusTab,
  providerScope,
  returnTo,
}: {
  organizationId: string;
  stage?: IntakeJourneyStage;
  statusTab?: IntakeStatusTab;
  providerScope?: string;
  returnTo?: string;
}): string {
  const params = new URLSearchParams({ tab: 'intake-hub', intakeStage: stage });
  if (statusTab) params.set('statusTab', statusTab);
  if (providerScope) params.set('providerScope', providerScope);
  const safeReturn = safeIntakeReturnTo(returnTo);
  if (safeReturn) params.set('returnTo', safeReturn);
  return `/admin-v2/organization/${encodeURIComponent(organizationId)}?${params}`;
}

/** A URL scope is usable only if it belongs to this loaded organization. */
export function resolveAdminProviderScope(search: string, memberIds: readonly string[]): string {
  const scope = new URLSearchParams(search).get('providerScope');
  return scope && memberIds.includes(scope) ? scope : '';
}
